/**
 * Panel de **alertas de salto de secuencia** del supervisor (`GET /alertas`).
 *
 * Replica el panel de alertas recientes del SSR `supervisor_talonarios`
 * (`progress/explore_talonarios_ssr.md`, §2.1 y §3.4): tabla con trabajador,
 * número omitido, número usado, registrado por y cuándo. Carga las alertas con
 * `useTalonarioAlertas` (polling) y permite marcarlas como vistas con
 * `useMarkAlertasVistas`. Presentacional + dos hooks de datos; sin `fetch`.
 *
 * Si no hay alertas, no se pinta nada (el SSR solo muestra el panel cuando hay).
 */
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "@/components/ui";

import { formatDateTime } from "../format";
import { useMarkAlertasVistas } from "../hooks/useMarkAlertasVistas";
import { useTalonarioAlertas } from "../hooks/useTalonarioAlertas";

export function TalonarioAlertasPanel() {
  const { data } = useTalonarioAlertas();
  const markVistas = useMarkAlertasVistas();

  const alertas = data?.alertas ?? [];
  if (alertas.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader className="flex items-center justify-between gap-4">
        <CardTitle>Alertas de salto ({alertas.length})</CardTitle>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          onClick={() => markVistas.mutate()}
          disabled={markVistas.isPending}
        >
          {markVistas.isPending ? "Marcando…" : "Marcar como vistas"}
        </Button>
      </CardHeader>
      <CardContent className="p-0">
        <Table>
          <TableHead>
            <TableRow>
              <TableHeaderCell>Trabajador</TableHeaderCell>
              <TableHeaderCell>Número omitido</TableHeaderCell>
              <TableHeaderCell>Número usado</TableHeaderCell>
              <TableHeaderCell>Registrado por</TableHeaderCell>
              <TableHeaderCell>Cuándo</TableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {alertas.map((alerta) => (
              <TableRow key={alerta.id}>
                <TableCell className="font-medium text-slate-900">
                  {alerta.worker}
                </TableCell>
                <TableCell>{alerta.numero_saltado}</TableCell>
                <TableCell>{alerta.numero_usado}</TableCell>
                <TableCell>{alerta.registrado_por ?? "—"}</TableCell>
                <TableCell>{formatDateTime(alerta.created_at)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
